import type {AppNewVersionService} from '.';
import type {Nullable} from '../../utils/utility-types';

export const lookupVersion = async (
  props: AppNewVersionService.VersionLookupProps,
): Promise<Nullable<string>> => {
  const versionUrl = (props as AppNewVersionService.VersionLookupPropsWeb)
    .versionUrl;

  const response = await fetch(versionUrl, {cache: 'no-store'});

  if (!response.ok) {
    throw new Error(
      `Failed to retrieve app version. Status ${response.status} ${response.statusText}`,
    );
  }

  const data = (await response.json()) as {version: string};

  return data.version;
};
